<template>
    <div class="firthree_content">
        <div class="firvipcontent">
            <p class="firviptitle">个人VIP</p>
            <p class="firvipsubtitle">专业、高效、省时、安全</p>
            <div class="firvipbocontent">
                <div class="vipbocontentli">
                    <div>专业</div>
                    <p>系统充分运用了区块链不可篡改的技术特性，客观记录作品的版权信息，利用大数据和人工智能技术，对比准确率可达95%以上</p>
                </div>
                <div class="vipbocontentli">
                    <div>高效</div>
                    <p>对比库全面覆盖国内主流库，24小时不间断更新</p>
                </div>
                <div class="vipbocontentli">
                    <div>省时</div>
                    <p>使用大数据支撑的智能算法，进行盗版监测和侵权取证；灵活运用智能合约机制，实现自动化的交易匹配</p>
                </div>
                <div class="vipbocontentli" style="margin-right:0px;">
                    <div>安全</div>
                    <p>及时排查侵权风险，提高风险防范能力。降低侵权事件发生的概率，减少侵权赔偿损失</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'firthree',
        data(){
            return {

            }
        },
        methods:{

        }
    }
</script>

<style scoped lang="less">
    .firthree_content{
        height:429px;
        background:url('./../../images/first10.png') center center no-repeat;
        background-size:cover;
        .firvipcontent{
            height:429px;
            display:flex;
            flex-direction:column;
            width:1334px;
            margin:0 auto;
            align-items: center;
            .firviptitle{
                height:42px;
                font-size:30px;
                font-weight:800;
                color:rgba(255,216,0,1);
                line-height:42px;
                letter-spacing:3px;
                margin-top:50px;
            }
            .firvipsubtitle{
                height:28px;
                font-size:20px;
                font-weight:400;
                color:rgba(255,216,0,1);
                line-height:28px;
                letter-spacing:2px;
                margin-top:10px;
                margin-bottom:60px;
            }
            .firvipbocontent{
                /*width:1334px;*/
                display:flex;
                justify-content: flex-start;
                .vipbocontentli{
                    width:250px;
                    margin-right:80px;
                    div{
                        height:28px;
                        font-size:20px;
                        font-weight:bold;
                        color:rgba(255,255,255,1);
                        line-height:28px;
                        letter-spacing:2px;
                    }
                    p{
                        margin-top:10px;
                        width:250px;
                        font-size:14px;
                        font-weight:400;
                        color:rgba(218,218,218,1);
                        line-height:24px;
                        letter-spacing:2px;
                    }
                }
            }
        }
    }
</style>